import './blocks/Spice_Heading'
import './blocks/Spice_Editor'
import './blocks/Spice_Divider'
import './blocks/Spice_Spacer'
import './blocks/Spice_Button'
import './blocks/Spice_Icon'
import './blocks/Spice_Section'
import './blocks/Spice_Column'
import './blocks/Spice_Image'
import './blocks/Spice_Blockquote'
import './blocks/Spice_CTA'
import './blocks/Spice_Timeline'
import './blocks/Spice_Accordion';
import './blocks/Spice_Icon_List';
import './blocks/Spice_Img_Comparison';
import './blocks/Spice_Gallery';
import './blocks/Spice_Img-Accordion';
import './blocks/Spice_Progress_Bar';
import './blocks/Spice_Service';
import './blocks/Spice_Social';
import './blocks/Spice_Socials';
import './blocks/admin';